import React from "react";
import useTranslation from "@nvs/gatsby-theme-leap-core/src/hooks/useTranslation";
import { RichText } from "@nvs/gatsby-theme-leap-core/src/components/hoc/components";

const Femara: React.FC<{}> = () => {
  const { t } = useTranslation();

  return (
    <div className="max-w-xl mx-auto w-full text-font flex flex-col gap-2">
      <p>{t("pages.confirmation.femara.title")}</p>
      <div className="flex flex-col text-left gap-2">
        <div className="flex gap-1">
          <div className="font-bold">{t("pages.confirmation.card.bin")}:</div>
          <div>{t("pages.confirmation.femara.bin")}</div>
        </div>
        <div className="flex gap-1">
          <div className="font-bold">{t("pages.confirmation.card.pcn")}:</div>
          <div>{t("pages.confirmation.femara.pcn")}</div>
        </div>
        <div className="flex gap-1">
          <div className="font-bold">{t("pages.confirmation.card.grp")}:</div>
          <div>{t("pages.confirmation.femara.grp")}</div>
        </div>
        <div className="flex gap-1">
          <div className="font-bold">{t("pages.confirmation.ftocard.id")}:</div>
          <div>{t("pages.confirmation.femara.id")}</div>
        </div>
      </div>
      <p>
        <RichText html={t("pages.confirmation.femara.contact")} />
      </p>
    </div>
  );
};

export default Femara;
